export const EVENTS_CONSTANTS = {
  INSCHOOL_GET_LOAN_OFFER: "INSCHOOL_GET_LOAN_OFFER",
};
